import React, {useEffect} from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import { RiMessengerLine } from 'react-icons/ri';
import { BsWhatsapp } from 'react-icons/bs';
import { useRef } from 'react';
// import emailjs from 'emailjs-com';
import emailjs from '@emailjs/browser'
import AOS from 'aos'
import 'aos/dist/aos.css'
const Contact = () => {
  useEffect(() => {
    AOS.init()
  })
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_grjnp7q', 'template_gfy0fzk', form.current, 'OIfB_KrmWkKysMQyt')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset();
  };
  return (
    <section id='contact' >
      <h5  data-aos="fade-up">Get In Touches</h5>
      <h2  data-aos="fade-up">Contact Me</h2>
      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option"  data-aos="fade-up">
            <MdOutlineEmail className='contact__icon' />
            <h4>Email</h4>
            <h5>kolawolekolapo20@gmail.com</h5>
            <a href="mailto:kolawolekolapo20@gmail.com" target='_blank' rel='noreferrer'>Send a message</a>
          </article>
          <article className="contact__option"  data-aos="fade-up">
            <RiMessengerLine className='contact__icon' />
            <h4>Messenger</h4>
            <h5>Kolapo Kolapwole </h5>
            <a href="https://m.me/profile.php?id=100077047778827" target='_blank' rel='noreferrer'>Send a message</a>
          </article>
          <article className="contact__option"  data-aos="fade-up">
            <BsWhatsapp className='contact__icon' />
            <h4>WhatsApp</h4>
            <h5>08146664972</h5>
            <a href="https://wa.me/+2348146664972" target='_blank' rel='noreferrer'>Send a message</a>
          </article>
        </div>
        <form ref={form} onSubmit={sendEmail}>
          <input type="text"  name='name' placeholder='Your Full Name' className='name' required  data-aos="fade-up"/>
          <input type="email" name='email'  placeholder='Your Email' className='email' required  data-aos="fade-up"/>
          <textarea name="message" id="" cols="30" rows="10" placeholder='Your Message' required  data-aos="fade-up"></textarea>
          
          <input type="submit" value="Send" className='btn btn-primary'  data-aos="fade-up"/>
        </form>
      </div>
    </section >
  )
}

export default Contact